// HTML生成器
const Util = require('./Util.js')
const agt = Util.getSearch().agt // 渠道
const link = agt ? '?agt=' + agt : ''

const Generate = {
    // return 单个新闻HTML字符串
    newsHtml: (data) => {
        let str = ''
        let date = Util.generateTime(data.date)

        if (data.images.length === '' || data.images.length === 'undefined') { return }

        // 无图
        if (data.images.length === 0) {

            str += `<div class="news-item">
              <h3 class="n-title"><a href="${data.path}${link}" target="_blank">${data.title}</a></h3>
              <div class="n-tool">
                <span class="original">${data.source}</span><span class="dot">·</span><span class="time">${data.published_at}</span>
              </div>
            </div>
            `

        }
        // 一张图
        else if (data.images.length && data.images.length <= 3) {

            str += `<div class="news-item">
              <div class="mixin">
                <a href="${data.path}${link}" target="_blank" class="m-pic"><img data-src="${data.images[0].src}?w=300"  alt="${data.images[0].alt}"></a>
                <div class="m-txt">
                  <h3 class="m-title"><a href="${data.path}${link}" target="_blank">${data.title}</a></h3>
                  <div class="n-tool">
                    <span class="original">${data.source}</span><span class="dot">·</span><span class="time">${data.published_at}</span>
                  </div>'
                </div>
              </div>
            </div>
          `

        }
        // 四张图
        else if (data.images.length >= 4) {

            str += `<div class="news-item">
            <h3 class="n-title"><a href="${data.path}${link}" target="_blank">${data.title}</a></h3>
            <div class="n-pic">
              <a href="${data.path}${link}" target="_blank">
                <div class="pic-item"><img data-src="${data.images[0].src}?w=300" alt="${data.images[0].alt}"></div>
                <div class="pic-item"><img data-src="${data.images[1].src}?w=300" alt="${data.images[1].alt}"></div>
                <div class="pic-item"><img data-src="${data.images[2].src}?w=300" alt="${data.images[2].alt}"></div>
                <div class="pic-item"><img data-src="${data.images[3].src}?w=300" alt="${data.images[3].alt}"></div>
              </a>
            </div>
            <div class="n-tool">
              <span class="original">${data.source}</span><span class="dot">·</span><span class="time">${data.published_at}</span>
            </div>
          </div>
          `
        }


        return str;
    },
    // return 标题头
    headerHtml: (title, children = '') => {
        let str = `
        <h2 class="title">
          <strong>${title}</strong>
          ${children}
        </h2>
      `
        return str
    },
    // 热点新闻
    hotHtml: (data) => {
        let str = Generate.headerHtml('热点新闻')
        str += `<ul class="hot_mixin_list">`
        for (let n in data) {
            str += `<li>`
            if (data[n].thumb) {
                str += `
              <a href="${data[n].path}${link}" class="m-img" target="_blank">
                <img data-src="${data[n].thumb}?w=180">
              </a>`
            }
            str += `
              <div class="m-txt">
                <h3 class="title"><a href="${data[n].path}${link}" target="_blank">${data[n].title}</a></h3>
                <div class="info"><a href="${data[n].path}${link}" target="_blank"><em>${data[n].view_count}</em>阅读</a></div>
              </div>
            <li>`
        }
        str += `</ul>`
        return str
    },
    // 热门图集--需要在数据列表中插入广告，单独一条返回
    hotPictureHtml: (data, large = '') => {
        let str = ''
        if (large) {

            str += `
          <li class="big-pic">
            <a href="${data.path}${link}" target="_blank">
              <div class="ppic"><img data-src="${data.thumb}?w=600"></div>
              <p class="ptxt">${data.title}</p>
            </a>
          </li>
          `
            return str
        }
        str += `
            <li>
              <a href="${data.path}${link}" target="_blank">
                <div class="ppic"><img data-src="${data.thumb}?w=300"></div>
                <p class="ptxt">${data.title}</p>
              </a>
            </li>
            `
        return str
    },
    // 推荐
    hotRecommendHtml: (data) => {
        let str = Generate.headerHtml('推荐')
        str += `<ul class="hot-list">`
        for (let n in data) {
            if (n < 3) {
                str += `
              <li>
                <em class="c">0${parseInt(n)+1}</em>
                <a href="${data[n].url}${link}" target="_blank">${data[n].title}</a>
              </li>`
            } else {
                str += `
              <li>
                <em>0${parseInt(n)+1}</em>
                <a href="${data[n].url}${link}" target="_blank">${data[n].title}</a>
              </li>`
            }
        }
        str += `</ul>`
        return str
    },
    // 娱乐
    hotsEntHtml: (data) => {
        let str = Generate.headerHtml('娱乐看点')
        str += `<ul class="pic_list">`
        for (let n in data) {
            str += `
          <li>
            <a href="${data[n].path}" target="_blank">
            <div class="ppic"><img data-src="${data[n].thumb}?w=300"></div>
            <p class="ptxt">${data[n].title}</p>
            </a>
          </li>
          `
        }
        str += `</ul>`
        return str
    },
    // 都市
    hotsCityHtml: (data) => {
        let str = Generate.headerHtml('都市新闻')
        let str_1 = `<ul class="pic_list">`,
            str_2 = `<ul class="txt_list">`

        for (let n in data) {

            if (n < 2) {
                str_1 += `
              <li>
                <a href="${data[n].path}${link}" target="_blank">
                  <div class="ppic"><img data-src="${data[n].thumb}?w=300"></div>
                  <p class="ptxt">${data[n].title}</p>
                </a>
              </li>
            `
            } else {
                str_2 += `
              <li>
                <a href="${data[n].path}${link}" target="_blank">${data[n].title}</a>
              </li>
            `
            }
        }
        str_1 += `</ul>`
        str_2 += `</ul>`
        return str + str_1 + str_2
    }
}

module.exports = Generate


// WEBPACK FOOTER //
// ./src/js/generateHtml.js